/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
		this.parent = this.closest('.product-recommendations--parent');
	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
					this.setupDrag();

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');
                      
						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
                            /* Activar Convert Test 12/09/24 */
                            if (window.runExperiment != 1) {
                              window.runExperiment = 1;
                              window._conv_q = window._conv_q || [];
                              window._conv_q.push(["executeExperiment","1004102526"]);
                              console.log("Convert Test Activo");
                            }
                            /* End Convert Test */
						}
					}

				}

				this.classList.add('product-recommendations--loaded');
				this.initDragToScroll();

			})
			.catch(e => {
				console.error(e);
			});
	}
	
	setupDrag() {
		const slider = this.querySelector('.cart-drawer--recommendations--products');
		if (!slider) return;

		let isDown = false;
		let startX;
		let scrollLeft;
		let isDragging = false;

		slider.addEventListener('mousedown', (e) => {
			isDown = true;
			isDragging = false;
			slider.classList.add('is-down');
			startX = e.pageX - slider.offsetLeft;
			scrollLeft = slider.scrollLeft;
		});

		slider.addEventListener('mouseleave', () => {
			isDown = false;
			slider.classList.remove('is-down');
			slider.classList.remove('is-dragging');
		});

		slider.addEventListener('mouseup', () => {
			isDown = false;
			slider.classList.remove('is-down');
			setTimeout(() => {
				slider.classList.remove('is-dragging');
			}, 0);
		});

		slider.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - slider.offsetLeft;
			const walk = (x - startX) * 2;
			if (Math.abs(walk) > 5) {
				isDragging = true;
				slider.classList.add('is-dragging');
			}
			slider.scrollLeft = scrollLeft - walk;
		});

		slider.addEventListener('click', (e) => {
			if (isDragging) {
				e.preventDefault();
				e.stopPropagation();
			}
		}, true);
	}

	connectedCallback() {
		this.fetchProducts();
	}

	initDragToScroll() {
		const slider = this.querySelector('.products.row');
		if (!slider) return;

		let isDown = false;
		let startX;
		let scrollLeft;
		let isDragging = false;

		slider.addEventListener('mousedown', (e) => {
			isDown = true;
			isDragging = false;
			slider.style.cursor = 'grabbing';
			slider.style.scrollSnapType = 'none';
			startX = e.pageX - slider.offsetLeft;
			scrollLeft = slider.scrollLeft;
		});
		slider.addEventListener('mouseleave', () => {
			isDown = false;
			slider.style.cursor = '';
			slider.style.scrollSnapType = '';
			slider.classList.remove('is-dragging');
		});
		slider.addEventListener('mouseup', () => {
			isDown = false;
			slider.style.cursor = '';
			slider.style.scrollSnapType = '';
			setTimeout(() => {
				slider.classList.remove('is-dragging');
				isDragging = false;
			}, 50);
		});
		slider.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - slider.offsetLeft;
			const walk = (x - startX);
			if (Math.abs(x - startX) > 5) {
				isDragging = true;
				slider.classList.add('is-dragging');
			}
			slider.scrollLeft = scrollLeft - walk;
		});
		slider.addEventListener('click', (e) => {
			if (isDragging) {
				e.preventDefault();
				e.stopPropagation();
			}
		}, true);

		const draggables = slider.querySelectorAll('img, a');
		draggables.forEach(el => {
			el.addEventListener('dragstart', (e) => e.preventDefault());
		});
	}
}

customElements.define('product-recommendations', ProductRecommendations);
